import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { GlobalContext } from "../Context/GlobalContext";

const ExportDocument = () => {
  const {
    translatedLabels,
    userEmail,
    exportScanDetails,
    setGlobalUserEmail,
    verifiedsecEmail,
    is4Life,
  } = useContext(GlobalContext);
  const location = useLocation();
  const { selectedIds } = location.state || { selectedIds: [] };
  const [enteredEmail, setEnteredEmail] = useState(
    is4Life ? verifiedsecEmail : userEmail || "",
  );
  const [requiresConsent, setRequiresConsent] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const screenLabels = translatedLabels?.common;
  const authLabel = translatedLabels?.auth;

  useEffect(() => {
    const baseEmail = is4Life ? verifiedsecEmail : userEmail;

    if (enteredEmail && enteredEmail !== baseEmail) {
      setRequiresConsent(true);
      setGlobalUserEmail(enteredEmail || userEmail);
    } else {
      setRequiresConsent(false);
      setIsChecked(false);
      setGlobalUserEmail("");
    }
  }, [enteredEmail, userEmail, verifiedsecEmail, is4Life]);

  const handleApprove = (exportType) => {
    const finalEmail = enteredEmail || (is4Life ? verifiedsecEmail : userEmail);

    exportScanDetails(finalEmail, "", selectedIds, exportType);
  };

  return (
    <div className="content-part">
      <div className="info-part mb-2">
        <p className="mb-2 text-muted">
          {screenLabels?.line_1?.label_value ||
            "Please confirm your email address to receive the exported document."}
        </p>
      </div>

      <div className="mb-3">
        <label className="form-label">
          {screenLabels?.email?.label_value || "Email"}
        </label>
        <input
          type="email"
          className="form-control"
          value={enteredEmail}
          onChange={(e) => setEnteredEmail(e.target.value)}
          placeholder="Enter your email"
        />
      </div>

      <div>
        <p className="fs-14px mb-0">
          <span className="fw-semibold">
            {screenLabels?.note_v2?.label_value || "Note"}:
          </span>
          {screenLabels?.export_note_v2?.label_value ||
            "After clicking export, please check your provided email to download the document."}
        </p>
      </div>

      {requiresConsent && (
        <div className="mb-3 mt-3">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="hipaaConsent"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
            />
            <label htmlFor="hipaaConsent">
              <p className="fs-15px">
                {screenLabels?.hipaa_v2?.label_value ||
                  "I understand that by choosing to receive my document via email, I am authorizing the disclosure of my personal health information to the specified recipients."}
              </p>
            </label>
          </div>
        </div>
      )}

      <div className="d-flex align-items-center justify-content-center mt-4">
        <button
          className="btn btn-primary"
          disabled={requiresConsent ? !isChecked : false}
          onClick={() => handleApprove("Document")}
        >
          {authLabel?.export?.label_value || "Export"}
        </button>
      </div>
    </div>
  );
};

export default ExportDocument;
